import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { renderColumns } from '@/components/modules/Hero/utils/renderColumns'
import { useInView } from 'framer-motion'
import { isEmpty, uniqueId } from 'lodash'

HeroContent.propTypes = {
  rows: PropTypes.array,
  loading: PropTypes.bool,
}

function HeroContent({ rows, loading }) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })

  if (isEmpty(rows)) return null

  return (
    <div className="main-container flex flex-col items-center justify-center">
      <h1 className="heading1 text-center uppercase leading-none mt-auto mb-auto" ref={ref}>
        {rows?.map((row, index) => {
          const rowKey = uniqueId()

          const column1 = row?.column1
          const column2 = row?.column2
          const columns = [column1, column2]

          const rowDelay = index * 0.5

          return (
            <span
              key={rowKey}
              className={`flex flex-col xl:flex-row space-x-0 xl:space-x-6 items-center xl:items-end justify-center overflow-hidden xl:mb-[14px]`}
            >
              {renderColumns({ columns, rowDelay, isInView, loading })}
            </span>
          )
        })}
      </h1>
    </div>
  )
}

export default React.memo(HeroContent)
